import * as tslib_1 from "tslib";
import { Exclude, Type } from 'class-transformer';
import { DimensionOptionResultDto } from '../../common/dimensions/dimension-option-result-dto';
const ɵ0 = () => DimensionOptionResultDto;
export class ARCreditApplicationTransactionItemResultDto {
    constructor() {
        this.isSelect = false;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Array)
], ARCreditApplicationTransactionItemResultDto.prototype, "dimensions", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", Number)
], ARCreditApplicationTransactionItemResultDto.prototype, "appliedAmount", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", Object)
], ARCreditApplicationTransactionItemResultDto.prototype, "isSelect", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", Array)
], ARCreditApplicationTransactionItemResultDto.prototype, "targetItems", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", Number)
], ARCreditApplicationTransactionItemResultDto.prototype, "sourceItemId", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", Number)
], ARCreditApplicationTransactionItemResultDto.prototype, "remainingOpenBalance", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", Number)
], ARCreditApplicationTransactionItemResultDto.prototype, "currentAppliedAmount", void 0);
export { ɵ0 };
